import React, { createContext, useContext, useState, useEffect } from 'react';

const LanguageContext = createContext(undefined);

export const LanguageProvider = ({ children }) => {
    // Get language from localStorage or default to 'pt'
    const [language, setLanguageState] = useState(() => {
        const savedLanguage = localStorage.getItem('preferredLanguage');
        return (savedLanguage === 'en' || savedLanguage === 'pt') ? savedLanguage : 'pt';
    });

    const setLanguage = (newLanguage) => {
        setLanguageState(newLanguage);
        localStorage.setItem('preferredLanguage', newLanguage);
    };

    useEffect(() => {
        // Get from localStorage on mount
        const savedLanguage = localStorage.getItem('preferredLanguage');
        if (savedLanguage && (savedLanguage === 'en' || savedLanguage === 'pt')) {
            setLanguageState(savedLanguage);
        } else {
            // Set default to Portuguese if no language is saved
            setLanguageState('pt');
            localStorage.setItem('preferredLanguage', 'pt');
        }
    }, []);

    return (
        <LanguageContext.Provider value={{ language, setLanguage }}>
            {children}
        </LanguageContext.Provider>
    );
};

export const useLanguage = () => {
    const context = useContext(LanguageContext);
    if (!context) {
        throw new Error('useLanguage must be used within a LanguageProvider');
    }
    return context;
};

